import React from 'react'

import { Box } from '../box'

const Loader = props => {
  return <Box className="vx_has-spinner-large" {...props} />
}

export default Loader
